// extracted by mini-css-extract-plugin
export default {"serviceCardWrapper":"ServiceSection_serviceCardWrapper__bzrf9","swingUpDown":"ServiceSection_swingUpDown__e3HlD"};